// Storage is denied outright in some contexts (blocked site data, private mode, quota): losing a
// preference across reloads is acceptable, breaking the render that reads it is not.
export const readStoredValue = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export const writeStoredValue = (key: string, value: string | null): void => {
  try {
    if (value === null) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    // no-op: the caller's in-memory snapshot still drives this tab
  }
}
